import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { BACKEND_URL } from "./../backendconfig";
import "./AdminNavbar.css";
const adminNavItems = [
  { to: "/MyAdmin/courses", label: "Courses", icon: "bi-journal-bookmark" },
  { to: "/MyAdmin/youtube", label: "YouTube Videos", icon: "bi-youtube" },
  {
    to: "/MyAdmin/embroidery-videos",
    label: "Embroidery Machine Videos",
    icon: "bi-youtube",
  },
  { to: "/MyAdmin/designers", label: "Designers", icon: "bi-people" },
  { to: "/MyAdmin/categories", label: "Categories", icon: "bi-grid" },
  { to: "/MyAdmin/media", label: "Upload Images", icon: "bi-images" },
  { to: "/MyAdmin/users", label: "User List", icon: "bi-person-lines-fill" },
  { to: "/MyAdmin/profile", label: "Profile", icon: "bi-person-circle" },
  {
    to: "/MyAdmin/change-password",
    label: "Change Password",
    icon: "bi-shield-lock",
  },
];

export default function AdminNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const [error, setError] = useState("");

  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setMenuOpen(false);
    setError("");
  }, [pathname]);

  async function handleLogout() {
    if (loggingOut) return;
    if (!window.confirm("Are you sure you want to log out?")) return;

    setLoggingOut(true);
    setError("");

    try {
      const response = await fetch(
        `${BACKEND_URL.replace(/\/+$/, "")}/admin-auth.php?action=logout`,
        {
          method: "POST",
          credentials: "include",
        },
      );

      const data = await response.json();

      if (!response.ok || !data.ok) {
        throw new Error(data.message || "Unable to log out.");
      }

      navigate("/MyAdmin/login", { replace: true });
    } catch (error) {
      setError(error.message);
    } finally {
      setLoggingOut(false);
    }
  }

  return (
    <nav
      className="ltc-admin-nav"
      aria-label="Admin navigation"
      onKeyDown={(event) => {
        if (event.key === "Escape") setMenuOpen(false);
      }}
    >
      <div className="ltc-admin-nav__inner">
        <Link className="ltc-admin-nav__brand" to="/MyAdmin/courses">
          <img
            src="/logo.jpg"
            alt="LifeTime"
            className="ltc-admin-nav__logo"
            width="48"
            height="48"
          />

          <span className="ltc-admin-nav__brand-text">
            <strong>LifeTime</strong>
            <small>Administration</small>
          </span>
        </Link>

        <button
          type="button"
          className="ltc-admin-nav__toggle"
          aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={menuOpen}
          aria-controls="ltc-admin-menu"
          onClick={() => setMenuOpen((previous) => !previous)}
        >
          <i
            className={`bi ${menuOpen ? "bi-x-lg" : "bi-list"}`}
            aria-hidden="true"
          />
        </button>

        <div
          id="ltc-admin-menu"
          className={`ltc-admin-nav__links${menuOpen ? " is-open" : ""}`}
        >
          {adminNavItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `ltc-admin-nav__link${isActive ? " is-active" : ""}`
              }
            >
              <i className={`bi ${item.icon}`} aria-hidden="true" />
              <span>{item.label}</span>
            </NavLink>
          ))}

          <button
            type="button"
            className="ltc-admin-nav__logout"
            disabled={loggingOut}
            onClick={handleLogout}
          >
            <i className="bi bi-box-arrow-right" aria-hidden="true" />
            <span>{loggingOut ? "Logging out…" : "Logout"}</span>
          </button>
        </div>
      </div>

      {error && (
        <p className="ltc-admin-nav__error" role="alert">
          {error}
        </p>
      )}
    </nav>
  );
}
